<template>
  <b-col id="sideBarContainer" >
    <b-nav class="d-none d-sm-block bg-light sidebar">
      <b-row align-h="center" class="mb-3">
        <b-col cols="10">
          <b-img src="/main/menu_logo.png" fluid/>
        </b-col>
      </b-row>

      <b-container>
        <ul class="list-unstyled">
          <li><router-link active-class="activeSide" to="/" exact>Start</router-link></li>
          <li><router-link active-class="activeSide" to="/aktualnosci">Aktualności</router-link></li>
          <li><router-link active-class="activeSide" to="/o_autorze">O Autorze</router-link></li>
          <li><router-link active-class="activeSide" to="/kolekcja">Kolekcja Janusza Bohdanowicza</router-link></li>
          <li><router-link active-class="activeSide" to="/historia">Historia AK na Wileńszczyźnie</router-link></li>
          <li><router-link active-class="activeSide" to="/srodowiska">Środowiska kombatanckie</router-link></li>
          <li><router-link active-class="activeSide" to="/sponsorzy">Sponsorzy</router-link></li>
          <li><router-link active-class="activeSide" to="/kontakt">Kontakt</router-link></li>
        </ul>
      </b-container>
    </b-nav>
  </b-col>
</template>

<script>
export default {
  name: 'sideBar'
}
</script>

<style scoped>
  #sideBarContainer ul{
    width: 250px;
  }

  @media screen and (max-width: 991px){
    #sideBarContainer{
      display: none;
    }
  }
  .sidebar {
    position: fixed;
    top: 0px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;

    overflow-x: hidden;
    overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;

    padding-left: 0;
    padding-right: 0;
  }

  a{color: grey;}
  .activeSide{color: #4286f4;}
</style>



// WEBPACK FOOTER //
// src/components/menu/sideBar.vue